import styled from 'styled-components';
import IconButton from '../../atoms/IconButton';
import TextButton from '../../atoms/TextButton';
import {SignInWithGoogleLogo} from '../../atoms/Logo';

export default {
	Wrapper : styled.div`
        
    `,
	Header : styled.h3`
    `,
	Body : styled.div`
        padding : 1rem 0;
        text-align : center;
    `,
	Description : styled.p`
        font-size :1.5rem;
    `,
	Footer : styled.div`
    `,
	TextButton,
	IconButton : styled(IconButton)`
    `,
	SignInWithGoogleLogo : styled(SignInWithGoogleLogo)`
        width : 70%;
    `
};